import {EstateFlowchartState, RevocableTrust} from "../../model/EstateFlowchartTypes";
import {FormValidationErrors, ValidationError} from "../ValidationTypes";
import {validateBasicInformation} from "../page/BasicInformationValidator";
import {validateBeneficiariesAtFirstDeath} from "../page/BeneficiariesAtFirstDeathValidator";
import FormPages from "../../config/FormPages";
import {validateRemainderBeneficiaries} from "../page/RemainderBeneficiariesValidator";

/**
 * Validates the form based on the current page and trust data.
 *
 * @param {string} pageName - The current page name of the form being validated.
 * @param {RevocableTrust} trust - The trust data to validate against.
 * @param enableEstateFlowchartMVPRelease
 * @param {EstateFlowchartState[]} flowcharts - The list of estate flowcharts for context in validation.
 * @param {string} flowchartId - The ID of the current flowchart being edited.
 * @returns {{formHasErrors: boolean, errors: any}} An object containing a boolean indicating if the form has errors and an object with the specific errors.
 */
export const validateForm = (pageName: string | undefined, trust: RevocableTrust, enableEstateFlowchartMVPRelease: boolean,
                             flowcharts: EstateFlowchartState[], flowchartId: string): FormValidationErrors => {
    let errors : ValidationError[] = [];

    if(trust) {
        switch (pageName) {
            case FormPages.BASIC_INFORMATION.id:
                errors = validateBasicInformation(trust, flowcharts, flowchartId, enableEstateFlowchartMVPRelease);
                break;
            case FormPages.BENEFICIARIES_AT_FIRST_DEATH.id:
                if(trust.beneficiaries?.firstDeathDistributions) {
                    errors = validateBeneficiariesAtFirstDeath(trust?.beneficiaries?.firstDeathDistributions, enableEstateFlowchartMVPRelease);
                }
                break;
            case FormPages.REMAINDER_BENEFICIARIES.id:
                if(trust.beneficiaries?.remainderDistributions) {
                    errors = validateRemainderBeneficiaries(
                        trust?.beneficiaries?.remainderDistributions,
                        enableEstateFlowchartMVPRelease,
                        trust?.beneficiaries?.additionalDistributions
                    );
                } else {
                    errors = validateRemainderBeneficiaries(
                        [],
                        enableEstateFlowchartMVPRelease,
                        trust?.beneficiaries?.additionalDistributions
                    );
                }
                break;
            case FormPages.ADDITIONAL_DISTRIBUTIONS.id:
                errors = validateRemainderBeneficiaries(
                    trust?.beneficiaries?.additionalDistributions?.distributions ?? [],
                    enableEstateFlowchartMVPRelease,
                    trust?.beneficiaries?.additionalDistributions
                );
                break;
        }
    }

    return {
        formHasErrors: errors.length > 0,
        errors: errors
    };
}